class cOptionsPayPal {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnSavePaypalOptions = $("#save-paypal-options-btn");
        this.elPaypalOptionsEditFrom = $('#paypal-form');
        $(elBtnSavePaypalOptions).click(function (e) { return self.submitPaypalOptions(this, e); });
    }
    submitPaypalOptions(btn, e) {
        $(btn).button('loading');
        $(this.elPaypalOptionsEditFrom).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updatepaypal/',
            type: 'post',
            dataType: 'json',
            data: {},
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
}
